import { createFileRoute } from "@tanstack/react-router";

import ArchivedRouteLabels from "@/components/RouteLabels/ArchivedRouteLabels";

export const Route = createFileRoute("/gym/$venueUuid/settings/labels/archive")({
  component: ArchivedRouteLabels,
});
